import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { useToggle } from 'javascripts/hooks/use-toggle';

import { ReactComponent as Arrow } from 'images/arrow-up.svg';

import styles from 'stylesheets/components/audiobook/collapsible_audiobook_section';

export function CollapsibleAudiobookSection({ children, title, toggle }) {
  const [expanded, toggleExpanded] = useToggle(toggle);

  const buttonLabel = useMemo(() => {
    return `${expanded ? 'Collapse' : 'Expand'} ${title} section`;
  }, [expanded]);

  function onToggleExpanded() {
    toggleExpanded();
    bubEvents.track('Audiobook page', `${expanded ? 'Collapsed' : 'Expanded'} section`, {
      label: title,
    });
  }

  function renderCollapseIcon() {
    return <Arrow className={classNames(styles.arrowIcon, { [styles.down]: !expanded })} />;
  }

  return (
    <section
      className={styles.collapsibleAudiobookSection}
      aria-label={title}
      data-testid='collapsible-audiobook-section'
    >
      <button className={styles.headerRow} onClick={onToggleExpanded} aria-label={buttonLabel}>
        <h3 className={styles.title}>{title}</h3>
        {renderCollapseIcon()}
      </button>
      <div
        data-testid='collapsible-audiobook-section-content'
        className={classNames(styles.children, { [styles.hidden]: !expanded })}
        aria-hidden={expanded ? 'false' : 'true'}
      >
        {children}
      </div>
    </section>
  );
}

CollapsibleAudiobookSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  toggle: PropTypes.bool,
};

CollapsibleAudiobookSection.defaultProps = {
  toggle: false,
};
